// extracted by mini-css-extract-plugin
export default {"icon":"_3-zQ1eyd","gray":"_4nIC4qqF","green":"_2RM_nDzD","white":"_3a9rrJDZ","greenHover":"H8MCBT0d","whiteHover":"nrys-Luy"};